export const dashboardFr = {
  // partagé — DashboardNav
  'dashboard.nav.ariaLabel': 'Sections du tableau de bord',
  'dashboard.nav.overview': 'Aperçu',
  'dashboard.nav.avatar': 'Avatar',
  'dashboard.nav.coins': 'Pièces',
  'dashboard.nav.contributions': 'Contributions',

  // partagé — StatusBadge (statut de contribution)
  'dashboard.status.draft': 'Brouillon',
  'dashboard.status.submitted': 'Soumis',
  'dashboard.status.communityReview': 'Examen communautaire',
  'dashboard.status.officialReview': 'Examen officiel',
  'dashboard.status.approved': 'Approuvé',
  'dashboard.status.rejected': 'Rejeté',
  'dashboard.status.unknown': 'inconnu',

  // partagé — ClaimStatusBadge
  'dashboard.claimStatus.pending': 'en attente',
  'dashboard.claimStatus.approved': 'approuvé',
  'dashboard.claimStatus.rejected': 'rejeté',

  // DashboardPage
  'dashboard.seo.title': 'Mon Grymwyrd',
  'dashboard.seo.description': 'Tes pièces, réclamations, contributions et personnages dans le crépuscule éternel.',
  'dashboard.displayNameFallback': 'Voyageur',
  'dashboard.welcomeBack': 'Bienvenue de retour',
  'dashboard.editAvatar': 'Modifier l\'avatar',
  'dashboard.loading': 'Rassemblement de ta légende…',
  'dashboard.avatarAlt': 'Portrait de {name}',
  'dashboard.offlineNotice':
    'Les données de profil en direct ne sont pas disponibles — affichage de ta dernière session et contenu exemple.',

  // DashboardPage — Carte Pièces
  'dashboard.coins.title': 'Pièces de la Tombe',
  'dashboard.coins.viewAll': 'Voir tout',
  'dashboard.coins.unit': 'pièces',
  'dashboard.coins.noActivity': 'Aucune activité de pièces pour l\'instant.',
  'dashboard.coins.fullHistory': 'Historique complet et acheter des pièces',

  // DashboardPage — Carte Contributions
  'dashboard.contributions.title': 'Contributions',
  'dashboard.contributions.manage': 'Gérer',
  'dashboard.contributions.empty': 'Aucune contribution pour l\'instant — rédige la première.',

  // DashboardPage — Carte Réclamations
  'dashboard.claims.title': 'Terres revendiquées de Grymwyrd',
  'dashboard.claims.empty': 'Tu ne possèdes encore aucun territoire à Grymwyrd.',
  'dashboard.claims.kindClaimed': '{kind} · revendiqué {date}',

  // DashboardPage — Carte Personnages
  'dashboard.characters.title': 'Personnages',
  'dashboard.characters.empty': 'Aucune âme liée à ton nom.',
  'dashboard.characters.level': 'Niv {level}',
  'dashboard.characters.unknown': 'Inconnu',

  // AvatarEditorPage
  'dashboard.avatarEditor.seo.title': 'Éditeur d\'avatar',
  'dashboard.avatarEditor.seo.description': 'Façonne le visage que tu montres au monde de Grymwyrd.',
  'dashboard.avatarEditor.heading': 'Éditeur d\'avatar',
  'dashboard.avatarEditor.errorNotImage': 'Ce fichier n\'est pas une image.',
  'dashboard.avatarEditor.errorNameRequired': 'Un nom est requis, même dans l\'obscurité.',
  'dashboard.avatarEditor.portrait': 'Portrait',
  'dashboard.avatarEditor.portraitPreview': 'Aperçu du portrait',
  'dashboard.avatarEditor.avatarPreviewAlt': 'Aperçu de l\'avatar',
  'dashboard.avatarEditor.zoom': 'Zoom',
  'dashboard.avatarEditor.zoomAria': 'Zoom sur le portrait',
  'dashboard.avatarEditor.panHorizontal': 'Déplacer le portrait horizontalement',
  'dashboard.avatarEditor.panVertical': 'Déplacer le portrait verticalement',
  'dashboard.avatarEditor.uploadAria': 'Télécharger l\'image du portrait',
  'dashboard.avatarEditor.changeImage': 'Changer l\'image',
  'dashboard.avatarEditor.uploadImage': 'Télécharger une image',
  'dashboard.avatarEditor.identity': 'Identité',
  'dashboard.avatarEditor.displayName': 'Nom affiché',
  'dashboard.avatarEditor.backstory': 'Histoire personnelle',
  'dashboard.avatarEditor.backstoryPlaceholder': 'D\'où viens-tu, et quel sombre destin courtises-tu ?',
  'dashboard.avatarEditor.publicProfile': 'Profil public',
  'dashboard.avatarEditor.publicVisible': 'Visible dans le Hall des Légendes.',
  'dashboard.avatarEditor.publicHidden': 'Caché aux autres voyageurs.',
  'dashboard.avatarEditor.saving': 'Sauvegarde…',
  'dashboard.avatarEditor.saveChanges': 'Enregistrer les modifications',
  'dashboard.avatarEditor.saved': 'Enregistré',

  // CoinHistoryPage
  'dashboard.coinHistory.checkoutUnavailable': 'Le paiement n\'est pas encore disponible — les coffres restent fermés.',
  'dashboard.coinHistory.notEnoughCoins': 'Pas assez de pièces pour cela.',
  'dashboard.coinHistory.reasonWorldClaim': 'Réclamation de territoire',
  'dashboard.coinHistory.reasonCosmetic': 'Cosmétique',
  'dashboard.coinHistory.spendReason': '{category} — {name}',
  'dashboard.coinHistory.spentNotice': 'Tu as dépensé {cost} pièces pour {name}.',
  'dashboard.coinHistory.seo.title': 'Pièces de la Tombe',
  'dashboard.coinHistory.seo.description': 'Ton registre complet de pièces, recharges et marchandises des morts.',
  'dashboard.coinHistory.heading': 'Pièces de la Tombe',
  'dashboard.coinHistory.balance': 'solde',
  'dashboard.coinHistory.buyCoins': 'Acheter des pièces',
  'dashboard.coinHistory.packCoins': '{coins} pièces',
  'dashboard.coinHistory.packBonus': ' + {bonus} bonus',
  'dashboard.coinHistory.summoningCheckout': 'Appel du paiement…',
  'dashboard.coinHistory.purchase': 'Acheter',
  'dashboard.coinHistory.spendCoins': 'Dépenser des pièces',
  'dashboard.coinHistory.insufficientCoins': 'Pièces insuffisantes',
  'dashboard.coinHistory.spending': 'Dépense…',
  'dashboard.coinHistory.spendAmount': 'Dépenser {cost}',
  'dashboard.coinHistory.historyTitle': 'Historique',
  'dashboard.coinHistory.tallyingLedger': 'Calcul du registre…',
  'dashboard.coinHistory.tableCaption': 'Historique des transactions de pièces',
  'dashboard.coinHistory.colReason': 'Raison',
  'dashboard.coinHistory.colAmount': 'Montant',
  'dashboard.coinHistory.noTransactions': 'Aucune transaction pour l\'instant.',

  // ContributionsPage
  'dashboard.contributionsPage.seo.title': 'Mes contributions',
  'dashboard.contributionsPage.seo.description':
    'La légende que tu as rédigée, et son passage sous le regard des modérateurs.',
  'dashboard.contributionsPage.heading': 'Contributions',
  'dashboard.contributionsPage.newContribution': 'Nouvelle contribution',
  'dashboard.contributionsPage.loading': 'Déroulement de tes parchemins…',
  'dashboard.contributionsPage.empty': 'Tu n\'as encore rédigé aucune légende. Commence ta première contribution.',
  'dashboard.contributionsPage.untitledDraft': 'Brouillon sans titre',
  'dashboard.contributionsPage.moderator': 'Modérateur :',
  'dashboard.contributionsPage.entryFallback': 'Entrée',
  'dashboard.contributionsPage.errorNameRequired': 'Toute création a besoin d\'un nom.',
  'dashboard.contributionsPage.modalTitle': 'Nouvelle contribution',
  'dashboard.contributionsPage.type': 'Type',
  'dashboard.contributionsPage.titleLabel': 'Titre',
  'dashboard.contributionsPage.summaryLabel': 'Résumé',
  'dashboard.contributionsPage.saveDraft': 'Enregistrer le brouillon',
  'dashboard.contributionsPage.submitting': 'Soumission…',
  'dashboard.contributionsPage.submitForReview': 'Soumettre pour examen',
}
